import PropTypes from 'prop-types';
import React from 'react';


export default function ImageLink({ className, imageUrl, href, target, children, color, handleOnClick }) {
  return (
    <a
      className={ `image-link ${className}` }
      href={ href }
      onClick={ handleOnClick }
      style={ { backgroundImage: `url('${imageUrl}')` } }
      target={ target }
    >
      <span className={ `image-link__text ${color}` }>
        { children }
      </span>
    </a>
  );
}

ImageLink.defaultProps = {
  children: null,
  className: '',
  color: '',
  handleOnClick: () => {},
  imageUrl: '',
  target: '_self',
};

ImageLink.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  handleOnClick: PropTypes.func,
  href: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  target: PropTypes.string,
};
